<template>
  <s-page v-if="loaded">
    <template v-slot:lateral-panel>
      <s-lateral-panel>
        <v-text-field placeholder="Rechercher" hide-details dense clearable v-model="recherche" class="ma-2" />
        <perfect-scrollbar style="height: 100%" id="services">
          <v-list subheader>
            <v-list-item-group color="primary">
              <template v-if="servicesQueJeDirige.length > 0">
                <v-subheader class="titre-groupe">
                  <v-icon class="mr-1" size="15">mdi-format-list-bulleted</v-icon>
                  Services que je dirige
                </v-subheader>
                <template v-for="(service, index) in servicesQueJeDirige">
                  <service-list-item :key="index + 1" :service="service" />
                </template>
                <v-divider class="mt-2 mb-1" />
              </template>
              <template v-if="servicesDontJeFaisParti.length > 0">
                <v-subheader class="titre-groupe">
                  <v-icon class="mr-1" size="15">mdi-format-list-bulleted</v-icon>
                  Services dont je fais parti
                </v-subheader>
                <template v-for="(service, index) in servicesDontJeFaisParti">
                  <service-list-item :key="index + 1" :service="service" />
                </template>
                <v-divider class="mt-2 mb-1" />
              </template>
              <template v-if="servicesDetablissement.length > 0">
                <v-subheader class="titre-groupe">
                  <v-icon class="mr-1" size="15">mdi-format-list-bulleted</v-icon>
                  Services d'établissement
                </v-subheader>
                <template v-for="(service, index) in servicesDetablissement">
                  <service-list-item :key="index + 1" :service="service" />
                </template>
                <v-divider class="mt-2 mb-1" />
              </template>
              <template v-for="(chefDeService, index) in chefsDeService">
                <v-subheader class="titre-groupe" :key="index + 1">
                  <v-icon class="mr-1" size="15">mdi-format-list-bulleted</v-icon>
                  Dirigés par {{ chefDeService.nomComplet }}
                </v-subheader>
                <template v-for="(service, index2) in getServicesByChefDeService(chefDeService.employeId)">
                  <service-list-item :key="index2 + 1" :service="service" />
                </template>
                <v-divider :key="-(index + 1)" class="mt-2 mb-1" />
              </template>
            </v-list-item-group>
          </v-list>
        </perfect-scrollbar>
        <service-create-dialog v-if="isInRole('ADMINISTRATEUR_' + selectedEtablissement.etablissementId)" />
      </s-lateral-panel>
    </template>
    <template v-slot:main-panel>
      <router-view />
    </template>
  </s-page>
</template>

<script>
import serviceCreateDialog from '@/components/service/service-create-dialog'
import serviceListItem from '@/components/service/service-list-item'
import { mapGetters } from 'vuex'
import { initialDataLoaded } from '../../store/modules/helpers'

export default {
  name: 'service',
  components: {
    serviceCreateDialog,
    serviceListItem,
  },
  data() {
    return {
      recherche: null,
    }
  },
  computed: {
    ...initialDataLoaded,
    ...mapGetters({
      services: 'service/getServices',
      selectedEtablissement: 'application/getSelectedEtablissement',
      isInRole: 'security/isInRoleSansBypassAdmin',
    }),
    loaded() {
      return initialDataLoaded && this.services
    },
    serviceList() {
      if (this.recherche === null || this.recherche === '') {
        return this.services
      } else {
        return this.services.filter((s) => !(s.nom.toLowerCase().indexOf(this.recherche.toLowerCase()) <= -1))
      }
    },
    servicesQueJeDirige() {
      return this.serviceList.filter((s) => this.isInRole('CHEF_DE_SERVICE_' + s.serviceId))
    },
    servicesDontJeFaisParti() {
      return this.serviceList.filter((s) => this.isInRole('MEMBRE_' + s.serviceId))
    },
    servicesDetablissement() {
      return this.serviceList.filter((s) => s.serviceId < 0)
    },
    chefsDeService() {
      let listeDesChefsDeService = []

      this.services.forEach((s) => {
        if (
          !this.laListeDemployesContient(listeDesChefsDeService, s.chefDeService) &&
          s.serviceId > 0 &&
          !this.isInRole('CHEF_DE_SERVICE_' + s.serviceId)
        ) {
          listeDesChefsDeService.push(s.chefDeService)
        }
      })

      return listeDesChefsDeService.sort((a, b) => a.nomComplet < b.nomComplet)
    },
  },
  methods: {
    getServicesByChefDeService(chefDeServiceEmployeId) {
      return this.serviceList.filter((s) => s.chefDeService.employeId === chefDeServiceEmployeId && s.serviceId > 0)
    },
    laListeDemployesContient(array, employe) {
      var i = array.length
      while (i--) {
        if (array[i].employeId === employe.employeId) {
          return true
        }
      }
      return false
    },
  },
}
</script>

<style>
.titre-groupe {
  text-transform: uppercase;
  font-size: 0.7em;
  padding-block: 0.25rem;
}
</style>
